"use strict";
import { useCallback, useEffect, useState } from "react";
function isVisibilityStateSupported() {
  return "visibilityState" in document;
}
function isWindowVisible() {
  return !isVisibilityStateSupported() || document.visibilityState !== "hidden";
}
export default function useIsWindowVisible() {
  const [focused, setFocused] = useState(false);
  const listener = useCallback(() => {
    setFocused(isWindowVisible());
  }, [setFocused]);
  useEffect(() => {
    if (!isVisibilityStateSupported()) {
      return void 0;
    }
    setFocused(() => isWindowVisible());
    document.addEventListener("visibilitychange", listener);
    return () => {
      document.removeEventListener("visibilitychange", listener);
    };
  }, [listener]);
  return focused;
}
